export default "__VITE_ASSET__CATr3XSf__"